import { createFileRoute } from '@tanstack/react-router';
import { SurveyResultsPage } from '@/features/people/pages/survey-results-page';

export const Route = createFileRoute('/_app/surveys/$id')({ component: SurveyRoute });

function SurveyRoute() {
  const { id } = Route.useParams();
  return <SurveyResultsPage id={id} />;
}
